import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import authContext from '@contexts/AuthContext';
import { UserActionType } from '@store/branches/user/enums';
import { fetchCurrentUserPermissions } from '@utilities/commonActions';

/** Loads user + permissions for the technician portal (no RootLayout). */
const TechnicianBootstrap: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const dispatch = useDispatch();
	const { user, setUser } = useContext(authContext) as any;

	useEffect(() => {
		if (user?.userId === undefined) {
			dispatch({
				type: UserActionType.FETCH_USER_DETAILS,
				payload: {
					successCB: (userRes: any) => setUser?.(userRes)
				}
			});
			return;
		}

		fetchCurrentUserPermissions(dispatch, user.userId, () => undefined);
	}, [dispatch, user?.userId, setUser]);

	return <>{children}</>;
};

export default TechnicianBootstrap;
